import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import localRequest from '../services/LocalServer/localRequest';
import { Button } from '@material-ui/core';
import Swal from 'sweetalert2';

const Synch = (props) => {
  let history = useHistory();
  const user = JSON.parse(localStorage.getItem('user'));
  const email = user?.role == 'Admin' ? user.email : user.referTo;
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (load) {
      Swal.fire({
        title: 'processing...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }
  }, [load]);

  useEffect(() => {
    if (!props.loginStatus) {
      history.push(`/machineSignIn/synch`);
    }
  }, []);

  const synchData = () => {
    setLoad(true);
    localRequest({
      method: 'post',
      url: '/synch',
      data: {
        token: localStorage.getItem('token'),
        machineID: localStorage.getItem('machineID'),
        email: email,
      },
    })
      .then(() => {
        setLoad(false);
        Swal.fire('Success!', 'All the data and files are synchronized', 'success');
      })
      .catch(() => {
        Swal.fire('Error!', 'Fail to synchronize all data and files ', 'error');
      });
  };

  const deleteData = () => {
    setLoad(true);
    localRequest({
      method: 'post',
      url: '/removeAll',
    })
      .then(() => {
        setLoad(false);
        Swal.fire('Success!', 'All the data and files are removed', 'success');
      })
      .catch(() => {
        Swal.fire('Error!', 'Fail to remove all data and files ', 'error');
      });
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh', width: '100vw' }}
    >
      <Button
        variant="contained"
        size="large"
        color="primary"
        style={{ marginRight: '100px' }}
        onClick={() => {
          synchData();
        }}
      >
        Synchronize data and Files
      </Button>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        onClick={() => {
          deleteData();
        }}
      >
        Delete all data and files
      </Button>
    </div>
  );
};

export default Synch;
